import axios from 'axios'

/**
 * @returns List of suggested subdomain label and validate the subdomain label
 */
export const validateSubdomainLabel = async (subDomain) => {
  const response = await axios.get(
    `tenants/validate-sub-domain${subDomain ? `?subDomain=${subDomain}` : ''}`
  )
  return response
}

/**
 * @param {object} payload Theme config object
 */
export const updateConfig = async (payload) => {
  const response = await axios.put('tenants/update-config', payload)
  return response
}

/**
 * @param {string} contestUri
 * @param {string} subDomainLabel
 * @returns {object} of configurations
 */
export const getConfig = async (contestUri = null) => {
  const response = await axios.get(
    `tenants/config${contestUri ? `?contestUri=${contestUri}` : ''}`
  )
  return response
}

/**
 * @param {object} payload
 * @returns
 */
export const updateAssets = async (payload) => {
  const response = await axios.put('tenants/assets', payload, {
    headers: { 'content-type': 'multipart/form-data' }
  })

  return response
}

/**
 * @param primary color
 * @returns HTML for email preview
 */
export const getEmailTemplateHtml = async (color) => {
  const encodedColor = color ? encodeURIComponent(color) : ''
  const response = await axios.get(
    `emails/preview-template${encodedColor ? `?color=${encodedColor}` : ``}`
  )
  return response
}

/**
 *
 * @param {string} subDomain
 * @returns
 */
export const updateSubDomain = async (subDomain) => {
  const response = await axios.put(
    `tenants/update-subdomain${subDomain ? `?subdomain=${subDomain?.trim()}` : ''}`
  )
  return response
}
